
import React from 'react';
import { withStyles, Grid, Typography, Tabs, Tab, withRouter } from '../../material-ui';
import MBack from '../view/MBack';
import { MatchPlayerMaterial, MatchPlayerTechnical } from './view';
import MTabPanel from '../view/MTabPanel';
import Apis from '../../network/Apis';
import MatchType from '../../model/MatchType';
import AppUtils from '../../control/apputlis';
import TabIndicator from '../view/TabIndicator';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

class MatchPlayerDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            data: null,
        };
        console.log('MatchPlayerDetail', props);
    }

    componentDidMount() {
        this.getPlayerInfo();
        AppUtils.YMPush('MAIN', 'MatchPlayerDetail');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getPlayerInfo = async () => {
        let { type_id, player } = this.props.location.data;
        if (type_id && player) {
            let result = await Apis.encryptionPlayerDetail(type_id, player.id);
            console.log('getPlayerInfo', result);
            if (result.code == 200) {
                this.setState({ data: result.data });
            }
        }

    }

    _handleChange(val) {
        this.setState({ value: val });
    }

    render() {
        const { classes } = this.props;
        const { value, data } = this.state;
        let { type_id } = this.props.location.data;
        let logo = '';
        if (data) {
            let HttpUrlPlayerFootBall = 'https://cdn.sportnanoapi.com/football/player/';
            let HttpUrlPlayerBasketBall = 'https://cdn.sportnanoapi.com/basketball/player/';
            if (data.logo.startsWith('http')) {
                logo = data.logo;
            } else {
                if (type_id == MatchType.BASKETBALL) {
                    logo = HttpUrlPlayerBasketBall + data.logo;
                } else if (type_id == MatchType.FOOTBALL) {
                    logo = HttpUrlPlayerFootBall + data.logo;
                }
            }
        }
        return (
            <MBack title='球员资料'>
                <Grid container alignItems='center' direction='row' style={{ marginTop: 32, marginBottom: 32 }}>
                    <img src={logo} alt='' style={{ width: 41, height: 41, objectFit: 'scale-down', marginLeft: 16 }}></img>
                    <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 16 }}>{data && data.name_zh}</Typography>
                </Grid>
                <Grid container justifyContent='space-between' alignItems='center' direction='row'>
                    <Grid container alignItems='center' style={{ flex: 1, backgroundColor: '#FFF', marginTop: 8 }}>
                        <Tabs
                            value={value}
                            onChange={(e, val) => this._handleChange(val)}
                            TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                            style={{ minHeight: 32, width: '100vw' }}
                        >
                            <Tab label='资料' style={{ color: value == 0 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                            <Tab label='技术统计' style={{ color: value == 1 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }}></Tab>
                        </Tabs>
                    </Grid>
                </Grid>
                <Grid container direction='row' className={classes.list} >
                    <MTabPanel value={value} index='0' style={{ width: '100%' }}>
                        <MatchPlayerMaterial data={data} type_id={type_id} />
                    </MTabPanel>
                    <MTabPanel value={value} index='1' style={{ width: '100%' }}>
                        <MatchPlayerTechnical data={data} type_id={type_id} />
                    </MTabPanel>
                </Grid>
            </MBack>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    list: {
        padding: theme.spacing(0, 0, 0, 0),
        marginTop: theme.spacing(0),
        backgroundColor: '#FFF',
    },
    indicator: {
        display: 'flex',
        backgroundColor: theme.palette.primary.main,
        padding: 0,
        '& > div': {
            backgroundColor: '#635ee700',
        },
        marginBottom: 0,
        height: 3,
        borderRadius: 1.5,
        maxWidth: '6vw',
        marginLeft: '22vw',
    },
    root: {
        minHeight: 28,
    },
    troot: {
        textTransform: 'none',
        color: '#878787',
        opacity: 1,
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(12),
        '&:focus': {
            opacity: 1,
        },
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        minWidth: '50vw',
        minHeight: 30,
    },
    selected: {
        color: '#0D0D0D',
        fontSize: theme.typography.pxToRem(12),
        verticalAlign: 'text-bottom',
        fontWeight: theme.typography.fontWeightRegular,
    },
    fullWidth: {
        flexBasis: 'auto',
        WebkitFlexBasis: 'auto',
        verticalAlign: 'text-bottom',
    },

}))(MatchPlayerDetail));